module.exports = __webpack_public_path__ + "static/media/close-modal.44c7bc1e.svg";